import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { TaskDetails } from '../../../models/admin/TaskDetails';
import { TaskDetailsResponse } from '../../../../interfaces/response/AdminPageResponses';

/**
 * An adapter converts task details HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class TaskDetailsAdapter implements Adapter<TaskDetails> {

  /**
   * Converts task details HTTP response to {@link TaskDetails}.
   * @param item task details HTTP response.
   */
  adapt(item: TaskDetailsResponse): TaskDetails {
    return new TaskDetails(
      item.type,
      item.status,
      item.lastComplete
    );
  }
}
